import { render, staticRenderFns } from "./registerLogin.vue?vue&type=template&id=a62c1024"
import script from "./registerLogin.vue?vue&type=script&lang=js"
export * from "./registerLogin.vue?vue&type=script&lang=js"
import style0 from "./registerLogin.vue?vue&type=style&index=0&id=a62c1024&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports